import { Text } from '@mantine/core'
import React from 'react'

import { VirtuosoEmptyPlaceholderProps } from './virtuoso-table-sections'

const VirtuosoEmptyPlaceholder = React.forwardRef<
  HTMLTableSectionElement,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  VirtuosoEmptyPlaceholderProps<any>
>(({ paginatedQuery, tableInstance, ...props }, ref) => {
  return paginatedQuery.isFetched &&
    tableInstance.getRowModel().rows.length === 0 ? (
    <tbody {...props} ref={ref}>
      <tr>
        <td colSpan={tableInstance.getAllColumns().length} align="center">
          <Text py="xl" size="xl" italic>
            {/* {t('table_no_results_check_filters')} */}
            {i18n.t(
              'table_no_results_check_filters',
              'Für Ihre Anfrage konnten keine Ergebnisse gefunden werden. Bitte überprüfen Sie Ihre Filter.',
            )}
          </Text>
        </td>
      </tr>
    </tbody>
  ) : (
    <tbody></tbody>
  )
})

VirtuosoEmptyPlaceholder.displayName = 'VirtuosoEmptyPlaceholder'
export default VirtuosoEmptyPlaceholder
